import { ITest, RHookFormTextFieldWithLabel } from "@websential/cosmic";

import { FC } from "react";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { Grid } from "@mui/material";

interface ICPPSettingsPanel extends ITest {
  selectedYear: number | string;
}

export const CPPSettingsPanel: FC<ICPPSettingsPanel> = ({ testId, selectedYear }) => {
  return (
    <Grid
      container
      columnSpacing={6}
      rowSpacing={2}
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
    >
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Total CPP Pensionable Earnings (Maximum)"
          id="cppSettingsTotalCppPensionableEarningsMaximum"
          testId={`${testId}-total-cpp-pensionable-earnings-maximum`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Basic CPP Exemption (Maximum)"
          id="cppSettingsBasicCppExemptionMaximum"
          testId={`${testId}-basic-cpp-exemption-maximum`}
        />
      </Grid>
      {selectedYear && Number(selectedYear) > 2023 ?
        <>
          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <RHookFormTextFieldWithLabel
              label="Total Second CPP Pensionable Earnings (Maximum)"
              id="cppSettingsTotalSecondCppPensionableEarningsMaximum"
              testId={`${testId}-total-second-cpp-pensionable-earnings-maximum`}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <RHookFormTextFieldWithLabel
              label="Second CPP Contribution Rate (%)"
              id="cppSettingsRequiredSecondContributionPercentage"
              testId={`${testId}-basic-second-cpp-exemption-maximum`}
            />
          </Grid></>
        : <></>}
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <FieldWrapper>
          <RHookFormTextFieldWithLabel
            label="Required Contribution (%)"
            id="cppSettingsRequiredContributionPercentage"
            testId={`${testId}-required-contribution-percentage`}
          />
        </FieldWrapper>
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}></Grid>
    </Grid>
  );
};
